import React, {FunctionComponent, useCallback, useEffect} from 'react'
import {useRootDispatch, useRootSelector} from '../../../utils/hooks'
import {ContactsUser} from '../../../responses/users'
import Field from '../../controls/Field/Field'
import SearchIcon from 'files/search.svg'
import {contactsActions} from '../../../redux/pages/contacts/users'
import styles from './ContactsPage.module.sass'
import ContactsMobileLine from './ContactsMobileLine'


const ContactsMobile: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const search = useRootSelector(state => state.pages.contacts.search)
    const data = useRootSelector(state => state.pages.contacts.data)

    const setSearch = useCallback((search: string) => {
        dispatch(contactsActions.list.init(search))
    }, [dispatch])

    useEffect(() => {
        setSearch(search)
    }, [setSearch, search])


    return <div className={styles.contactsMobile}>
        <div className={styles.header}>
            <div className={styles.pageTitle}>Контакты</div>
            <Field placeholder={'Поиск по контактам'} className={styles.field} rightItem={<SearchIcon/>} value={search}
                   onChange={setSearch}/>
        </div>
        <div className={styles.lines}>
            {
                data.map((item: ContactsUser, key: number) => {
                    return <ContactsMobileLine
                        key={key}
                        departments={item.departments}
                        directions={item.directions}
                        phone={item.phone}
                        email={item.email}
                        position={item.position}
                        skype={item.skype}
                        watsapp={item.watsapp}
                        name={item.name}/>
                })
            }
        </div>
    </div>
}

export default ContactsMobile
